import { EMPTY_EDITOR_VALUE } from '../types/types';

const BOM = '﻿';

/**
 * Convert a `.txt` File/Blob into a Plate value: one paragraph block per
 * line. Mirrors docxBlobToPlateValue's return shape (a Plate node array, or
 * EMPTY_EDITOR_VALUE for content-free input) so DocxDrawer can pick either
 * converter interchangeably.
 */
export async function txtBlobToPlateValue(blob: Blob): Promise<any[]> {
    const raw = await blob.text();
    const text = raw.startsWith(BOM) ? raw.slice(BOM.length) : raw;
    if (!text.trim()) return EMPTY_EDITOR_VALUE as any[];

    return text.split(/\r\n|\r|\n/).map((line) => ({ type: 'p', children: [{ text: line }] }));
}
